import { detectStructure, getAnalyzedCandles } from "./structureEngine";
import { detectMarketTrend, DEFAULT_TREND_LINE_SETTINGS } from "./SwingDetector";
import { detectValidBreakout } from "./BreakoutDetector";

function buildLine(direction, swings, lastTime) {
  const first = swings[0];
  const last = swings[swings.length - 1];
  const slope = (last.price - first.price) / (last.time - first.time || 1);
  const points = [
    { time: first.time, value: first.price },
    { time: last.time, value: last.price },
  ];
  if (lastTime > last.time) points.push({ time: lastTime, value: last.price + slope * (lastTime - last.time) });
  return { direction, swings, points, signature: `${direction}:${swings.map((swing) => swing.time).join(",")}` };
}

/** Stateful coordinator: it only changes its render model after a pivot, breakout, or MSS. */
export class TrendLineManager {
  constructor(settings = {}) {
    this.settings = { ...DEFAULT_TREND_LINE_SETTINGS, ...settings };
    this.activeLine = null;
    this.breakout = null;
    this.lastClosedTime = null;
  }

  update(candles) {
    if (!this.settings.trendLineEnabled) return { line: null, changed: Boolean(this.activeLine), glowing: false };
    const closed = getAnalyzedCandles(candles);
    const latest = closed.at(-1);
    if (!latest) return { line: null, changed: false, glowing: false };
    const trend = detectMarketTrend(closed, this.settings);
    const candidate = trend.direction ? buildLine(trend.direction, trend.swings, latest.time) : null;
    let changed = false;

    if (!this.activeLine && candidate) { this.activeLine = candidate; changed = true; }
    if (this.activeLine && !this.breakout) {
      const breakout = detectValidBreakout(this.activeLine, closed);
      if (breakout && breakout.time !== this.lastClosedTime) { this.breakout = breakout; changed = true; }
      else if (candidate && candidate.signature !== this.activeLine.signature) { this.activeLine = candidate; changed = true; }
    }

    if (this.breakout) {
      const structure = detectStructure(closed);
      const hasMss = structure.latestEvent?.bosCandleTime >= this.breakout.time && structure.latestEvent?.direction === (this.breakout.direction === "UP" ? "BULLISH" : "BEARISH");
      if (hasMss && candidate && candidate.direction === this.breakout.direction) {
        this.activeLine = candidate;
        this.breakout = null;
        changed = true;
      }
    }
    this.lastClosedTime = latest.time;
    return { line: this.activeLine, changed, glowing: Boolean(this.breakout), breakout: this.breakout };
  }
}
